export default __webpack_public_path__ + "static/media/icon-search.188a4fb6.svg";